import { useCallback } from "react";
import { CheckBox, SingleFilePicker, Validator } from "react-admin-base-bootstrap";
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { FreeSelect, LanguageSelect, UserSelect } from "./Selects";
import SeoEntity from "./SeoEntity";
import { WordCounter } from "./WordCounter";
import { makeSlug } from 'react-admin-base';
import { CKEditorWithUpload as CKEditor } from 'react-admin-base-ckeditor';
import {Field} from "./Fields";
import CodeEditor from "./CodeEditor";

export function ContentInput({ value, onChange }) {
	const setData = useCallback(function(data) {
		onChange({ ...(value || {}), ...data });
	}, [ value, onChange ]);
	
	return <>
		<Card>
			<CardBody>
				<CheckBox
					type="checkbox"
					id="active"
					label="Active"
					className="mb-3"
					checked={(value && value.enabled) || false}
					onChange={a => setData({ enabled: !value?.enabled })}
				/>
				<Row>
					<Col>
						<FormGroup>
							<Label>Name</Label>
							<Validator name="name" type="required">
								<Input
									type="text"
									value={value?.name || ''}
									onChange={a => setData({
										name: a.currentTarget.value,
										slug: (value?.slug || '') === makeSlug(value?.name || '') ? makeSlug(a.currentTarget.value) : value?.slug
									})}
								/>
							</Validator>
						</FormGroup>
					</Col>
					<Col>
						<FormGroup>
							<Label>Slug</Label>
							<Validator name="slug" type="required">
								<Input
									type="text"
									value={value?.slug || ''}
									onChange={a => setData({slug: a.currentTarget.value})}
								/>
							</Validator>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col>
						<FormGroup>
							<Label>Tag(s)</Label>
							<Validator name="tags" type="required">
								<FreeSelect
									value={value?.tags}
									onChange={a => setData({ tags: a })}
									isMulti
								/>
							</Validator>
						</FormGroup>
					</Col>
					<Col>
						<FormGroup>
							<Label>Language</Label>
							<LanguageSelect
								value={value?.language}
								onChange={a => setData({language: a})}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col>
						<FormGroup>
							<Label>Author</Label>
							<Validator name="author" type="required">
								<UserSelect
									value={value?.author}
									onChange={a => setData({ author: a })}
								/>
							</Validator>
						</FormGroup>
					</Col>
					<Col>
						<FormGroup>
							<Label>Published at</Label>
							<Validator name="published_at" type="required">
								<Input
									type="datetime-local"
									bsSize="lg"
									value={value?.published_at}
									onChange={a => setData({ published_at: a.currentTarget.value })}
								/>
							</Validator>
						</FormGroup>
					</Col>
				</Row>
				<FormGroup>
					<Label>Focus Word</Label>
					<Input
						type="text"
						value={value?.focused || ''}
						onChange={a => setData({ focused: a.currentTarget.value })}
					/>
				</FormGroup>
			</CardBody>
		</Card>
		<Card>
			<CardBody>
				<FormGroup>
					<Label>Abstract</Label>
					<Input
						type="textarea"
						rows={4}
						value={value?.abstract || ''}
						onChange={a => setData({ abstract: a.currentTarget.value })}
					/>
				</FormGroup>
			</CardBody>
		</Card>
        <Card>
            <CardBody>
                <CheckBox
                    className="mb-0"
                    type="checkbox"
                    checked={!!value?.is_html}
                    onChange={() => setData({ is_html: !value?.is_html })}
                    label="Use Raw HTML Code"
                />
            </CardBody>
            { !!value?.is_html && <CodeEditor
                value={value?.body || ''}
                onChange={a => setData({ body: a })}
                syntax="html"
            /> }
        </Card>
        { !value?.is_html && <Card>
			<CKEditor
				value={value?.body || ''}
				onChange={a => setData({ body: a })}
			/>
            <CardBody>
                <WordCounter
                    focusWord={value?.focused || ''}
                    value={value?.content || ''}
                />
            </CardBody>
        </Card> }
		<Card>
			<CardBody>
				<FormGroup>
					<Label>Featured image</Label>
					<SingleFilePicker
						accepts="image/*"
						value={value?.featured_image}
						onChange={a => setData({ featured_image: a })}
					/>
				</FormGroup>
			</CardBody>
		</Card>
		<Card>
			<CardBody>
				<SeoEntity
					value={value?.seo}
					onChange={seo => setData({ seo })}
				/>
			</CardBody>
		</Card>
	</>;
}